import { IContractHours } from 'types/availabilities';
import { ContractHoverPanel, ContractMiniCard, ContractMiniCardFunction, ContractMiniCardHours } from './styles';

interface ContractHoursHoverCardProps {
  contractHours: IContractHours[];
}

const ContractHoursHoverCard = ({ contractHours }: ContractHoursHoverCardProps) => (
  <ContractHoverPanel>
    {contractHours.map((contract, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ContractMiniCard key={`${contract.start}-${contract.end}-${index}`}>
        <ContractMiniCardHours>{`${contract.start} - ${contract.end}`}</ContractMiniCardHours>
        {contract.function && <ContractMiniCardFunction>{contract.function}</ContractMiniCardFunction>}
      </ContractMiniCard>
    ))}
  </ContractHoverPanel>
);

export default ContractHoursHoverCard;
